/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Emphasis/theme';

export const EmphasisTheme = theme;
